// extracted by mini-css-extract-plugin
module.exports = {"navigationButtons":"form-navigation_navigationButtons___x5i2","linkButton":"form-navigation_linkButton__6LXHz","active":"form-navigation_active__7fNz1"};